import { ImageModeEnum as e, ImageNameEnum as t } from "./image-enum.mjs";
import { Node as n, Tracker as r, findChildrenInRange as i, mergeAttributes as a } from "@tiptap/core";
//#region src/extensions/image-extension/image.ts
var o = n.create({
	name: "image",
	addOptions() {
		return { inline: !1 };
	},
	inline() {
		return this.options.inline;
	},
	group() {
		return this.options.inline ? "inline" : "block";
	},
	draggable: !0,
	addAttributes() {
		return {
			src: { default: null },
			alt: { default: null },
			title: { default: null },
			imageMode: { default: null },
			width: { default: null },
			height: { default: null },
			href: { default: null },
			containerWidth: { default: "auto" },
			caption: { default: null },
			uploadingProps: { default: null },
			isMobileFullWidth: { default: !1 }
		};
	},
	parseHTML() {
		return [{ tag: "img[src]:not([src^=\"data:\"])" }];
	},
	renderHTML({ HTMLAttributes: e }) {
		return ["img", a(this.options.HTMLAttributes, e)];
	},
	addCommands() {
		return {
			setImage: (n) => ({ commands: r }) => {
				let i;
				switch (n.imageMode) {
					case e.Inline:
						i = t.Inline;
						break;
					case e.BlockRight:
					case e.BlockCenter:
						i = t.Block;
						break;
					default: i = "image";
				}
				return r.insertContent({
					type: i,
					attrs: n
				});
			},
			toggleImageMode: (n) => ({ tr: a, commands: o }) => {
				let { doc: s, selection: c } = a, { from: l, to: u } = c, d = i(s, {
					from: l,
					to: u
				}, (e) => e.type.name === t.Inline || e.type.name === t.Block);
				if (!d.length) return !1;
				let f = new r(a);
				return o.forEach(d, ({ node: r, pos: i }) => {
					let s = f.map(i);
					if (s.deleted) return !1;
					let c = {
						from: s.position,
						to: s.position + r.nodeSize
					}, u = o.insertContentAt(c, {
						type: n === e.Inline ? t.Inline : t.Block,
						attrs: {
							...r.attrs,
							imageMode: n,
							caption: n === e.Inline ? void 0 : r.attrs.caption,
							float: n === e.BlockRight ? "right" : null
						}
					}), d = s.position - 1;
					if (d >= 0) {
						let e = a.doc.nodeAt(d);
						e?.type.name === "paragraph" && e.nodeSize === 2 && a.delete(d, d + e.nodeSize);
					}
					return n === e.Inline && (r.attrs.imageMode === e.BlockCenter || r.attrs.imageMode === e.BlockRight) && o.setNodeSelection(l + 1), u;
				});
			}
		};
	}
});
//#endregion
export { o as Image };
